// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"fde6a20b","804":"04279ae1","855":"b65936bc"}[chunkId] + ".chunk.css";
};